<template>
  <div class="row">
    <el-container>
      <el-aside width="200px">
        <el-menu >
          <el-menu-item><router-link tag='div' to='/eventMsg/tstq' >特殊天气</router-link></el-menu-item>
          <el-menu-item><router-link tag='div' to='/eventMsg/jtsg' >交通事故</router-link></el-menu-item>
          <el-menu-item><router-link tag='div' to='/eventMsg/dlyh' >道路养护与灾毁</router-link></el-menu-item>
        </el-menu>
      </el-aside>
      <el-main >
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "transNews",
  data() {
    return {
    };
  },
  
};
</script>
<style scoped>
.el-container {
  height:700px;
  width: 100%;
}
.el-aside {
  background-color: #f3f4f5;
  overflow: hidden;
  margin-right: 5px;
}
.el-menu-item {
  /* padding: 0; */
  background-color: #f3f4f5;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px dashed #ccc;
}

.el-main {
  padding: 0;
}
.el-menu-item div{
  text-align: center;
  /* border:1px solid red; */
}
.router-link-active{
  color: rgba(1, 152, 251, 1);;
}
</style>


// WEBPACK FOOTER //
// src/pages/eventmsg/index.vue